<template>
	<section class="other_page_banner banner_nxt_sec_not_touch">
		<div class="container">
			<div class="row">
				<div class="col-sm-6 order-2 order-md-1">
					<div class="ban_lt">
						<h2>
							{{
								$t('new_ui.business_pay_method_page.section_banner.title.one')
							}}
							<br />{{
								$t('new_ui.business_pay_method_page.section_banner.title.two')
							}}
						</h2>
						<h6>
							{{
								$t('new_ui.business_pay_method_page.section_banner.main_title')
							}}
						</h6>
						<p>
							{{
								$t(
									'new_ui.business_pay_method_page.section_banner.paragraph.one',
								)
							}}
						</p>

						<div
							class="ban_lt_btn d-flex justify-content-start align-items-center p-top"
						></div>
					</div>
				</div>
				<div class="col-sm-6 order-1 order-md-2">
					<div class="ban_rt">
						<img :src="img.image1" alt="Logo" />
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="question_sec method_mid">
		<div class="container">
			<div class="row">
				<div class="col-sm-5">
					<div class="question_lt">
						<img :src="img.image2" alt="" />
					</div>
				</div>
				<div class="col-sm-7">
					<div class="question_rt">
						<div class="payment_world_right">
							<span>{{
								$t('new_ui.business_pay_method_page.method_mid.label')
							}}</span>
							<div class="payment_world_txt">
								<h4>
									{{
										$t('new_ui.business_pay_method_page.method_mid.title.one')
									}}
									<br />{{
										$t('new_ui.business_pay_method_page.method_mid.title.two')
									}}
									<span>{{
										$t('new_ui.business_pay_method_page.method_mid.title.three')
									}}</span>
									{{
										$t('new_ui.business_pay_method_page.method_mid.title.four')
									}}
								</h4>
								<p>
									{{
										$t(
											'new_ui.business_pay_method_page.method_mid.paragraph.one',
										)
									}}
								</p>
								<p>
									{{
										$t(
											'new_ui.business_pay_method_page.method_mid.paragraph.two',
										)
									}}
								</p>
								<div class="starting_to_btn pay_world">
									<a href="/auth/register">{{
										$t(
											'new_ui.business_pay_method_page.method_mid.cta_buttons.one',
										)
									}}</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="withdraw_sec">
		<div class="container">
			<div class="row">
				<div class="col-sm-12">
					<div class="withdraw_inn">
						<span>{{
							$t('new_ui.business_pay_method_page.withdraw_sec.label')
						}}</span>
						<h4>
							{{ $t('new_ui.business_pay_method_page.withdraw_sec.title.one') }}
							<span>{{
								$t('new_ui.business_pay_method_page.withdraw_sec.title.two')
							}}</span>
							{{
								$t('new_ui.business_pay_method_page.withdraw_sec.title.three')
							}}
							<span>{{
								$t('new_ui.business_pay_method_page.withdraw_sec.title.four')
							}}</span>
						</h4>
						<div class="row d-none d-lg-block">
							<div class="col-sm-10 offset-sm-1">
								<div class="withdraw_mid">
									<div class="withdraw1"><img :src="img.image3" alt="" /></div>
									<div class="withdraw2"><img :src="img.image4" alt="" /></div>
									<div class="withdraw1"><img :src="img.image5" alt="" /></div>
								</div>
							</div>
						</div>
						<div class="row d-block d-lg-none">
							<div class="col-sm-12">
								<img :src="img.image6" alt="" />
							</div>
						</div>
						<p>
							{{ $t('new_ui.business_pay_method_page.withdraw_sec.paragraph') }}
						</p>
						<div class="starting_to_btn">
							<a href="/auth/register">{{
								$t(
									'new_ui.business_pay_method_page.withdraw_sec.cta_buttons.one',
								)
							}}</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="newsletter_sec">
		<div class="container">
			<div class="row">
				<div class="col-sm-12 col-xxl-5 col-xl-5 col-lg-5 col-md-12">
					<div class="newsletter_lt">
						<span>{{
							$t('new_ui.business_pay_method_page.section_newsletter.label')
						}}</span>
						<div class="newsletter_txt">
							<h4>
								<span>{{
									$t(
										'new_ui.business_pay_method_page.section_newsletter.title.one',
									)
								}}</span>
								{{
									$t(
										'new_ui.business_pay_method_page.section_newsletter.title.two',
									)
								}}
							</h4>
						</div>
					</div>
				</div>
				<div class="col-sm-12 col-xxl-7 col-xl-7 col-lg-7 col-md-12">
					<div class="newsletter_rt">
						<p>
							{{
								$t(
									'new_ui.business_pay_method_page.section_newsletter.description.one',
								)
							}}
						</p>
						<form>
							<div class="news_mail">
								<div class="news_mail_lt">
									<input
										type="email"
										:placeholder="
											$t(
												'new_ui.business_pay_method_page.section_newsletter.form.placeholder',
											)
										"
									/>
								</div>
								<div class="news_mail_rt">
									<button type="submit" value="submit">
										{{
											$t(
												'new_ui.business_pay_method_page.section_newsletter.form.button',
											)
										}}
									</button>
								</div>
							</div>
						</form>
						<p class="mt-3">
							{{
								$t(
									'new_ui.business_pay_method_page.section_newsletter.description.two',
								)
							}}
						</p>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>
<script>
import methodban from '@/assets/images/sub/method_ban.png';
import m1 from '@/assets/images/sub/m1.png';
import m2 from '@/assets/images/sub/w1.png';
import m3 from '@/assets/images/sub/exch_logo1.png';
import m4 from '@/assets/images/sub/m4.png';
import m5 from '@/assets/images/sub/method_mob.png';

export default {
	data: () => {
		return {
			img: {
				image1: methodban,
				image2: m1,
				image3: m2,
				image4: m3,
				image5: m4,
				image6: m5,
			},
		};
	},
};
</script>
